import type { FaireProductEntity } from "../../entity_types/product";

export const p_2x3zgznkfq: FaireProductEntity = {
  token: "p_2x3zgznkfq",
  type: "product",
  name: "I ❤️ Romance Novels Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/6a21710bf7e93a65ee7782fc66f255ad61ab96e443dc82777fe4570d3f534f97.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8945114c4d82218da43f8da4e5edee1ad1fd8400f7dfc057ac52f839307ff28b.jpeg",
    "https://cdn.faire.com/fastly/c03bb20f1dedf1cdd411dac741c41a42e195e7b51b92d3b432233cacdccf6ca3.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/018563442d2c44496870489ea12a564a4a982dc1671fa469ed2ed8f180d69980.jpeg",
    "https://cdn.faire.com/fastly/26eaf37df6d68d25ac867944b643e5595984ff5ac167b2fefe6404679e06d97d.jpeg",
    "https://cdn.faire.com/fastly/209e81d9d1e6f8d06ee906892d53dad4ca44928057ca47b79d3a73eaf07080f2.jpeg",
    "https://cdn.faire.com/fastly/58cbe76f120000fd9fc67797b63347c1e0724f5dd9945b3175882ebda26faa46.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nIf you like to lose yourself in the throes of passion when you dive face-first into a steamy romance novel, you'll almost certainly want to dive feet-first into these sexy 'lil socks. 😍 📚 😈\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:11.121Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
